import * as React from 'react'
import i18next from 'i18next'
import { Spinner } from '../Spinner'

/** Floating pill shown while more items are being appended to a list. */
export const FetchingLoader: React.FC = () => (
  <div className="fixed bottom-4 left-1/2 -translate-x-1/2 sm:left-4 sm:translate-x-0 z-50">
    <div className="flex items-center gap-2 px-4 py-2 bg-white rounded-full shadow-lg border border-gray-100">
      <Spinner size="sm" />
      <span className="text-sm font-medium text-gray-700">{i18next.t('loading.text')}</span>
    </div>
  </div>
)
